export const AboutPanel = () => {
  return (
    <div style={{ fontSize: 'small', overflowY: 'scroll', maxHeight: 700 }}>
      <h1>
        <i>Github Issue Log Recipe</i>
      </h1>
      <div>
        <p>
          <a href=""></a>
          This demo mimics a typical Issue Log tracker using data from Github
          Issues.
        </p>
        <p>
          It demonstrates many of the features in AdapTable designed to improve
          user workflows and boost productivity
        </p>
        <p>
          The demo was built in 1 day and required <b>no custom code</b> -
          everything was achieved using properties and code provided by
          AdapTable.
        </p>
        <h2>Data</h2>
        <p>
          The data displayed in the demo application is genuine and sourced in
          real-time.{' '}
        </p>
        <p>
          However, for illustration purposes, we have created a{' '}
          <i>Current User</i> (which defaults to 'Jonny Wolfson') to whom we
          assign 3 issues intially.{' '}
        </p>
        <p>
          Every 5 seconds a (randomly selected) existing Issue is assigned to
          the <i>Current User</i>.{' '}
        </p>
        <p>
          When this happens the demo application triggers an{' '}
          <a
            href="https://docs.adaptabletools.com/guide/handbook-alerting"
            target="_blank"
          >
            Alert
          </a>{' '}
          with an <b>Action Button</b> to set the <i>State</i> of that Issue to{' '}
          <i>In Progress</i>.
        </p>
        <h2>Workflow</h2>
        <p>The demo application is designed to mimic some basic workflows. </p>
        <p>
          The <i>Current User</i> (in this case 'Jonny') can:
          <ul>
            <li>
              Assign any Issue to any user (via a dropdown which appears when
              editing the <i>Assigned To</i> column)
            </li>
            <li>
              Assign Issues to himself (via a dedicated Button in the row, or
              the 'Assign to Me' context menu option)
            </li>
          </ul>
          For those Issues already assigned to the <i>Current User</i>, he can:
          <ul>
            <li>
              Change the State of the Issue (with different options depending on
              the current State)
            </li>
            <li>Open / Close the Issue via shortcut Buttons in each Row</li>
            <li>Close all his Issues via a Button in the 'Edit' Tab </li>
            <li>
              See just his Issue via a Button in the 'Edit' Tab or the 'My
              Assignments' option in the <i>Assigned To</i> column filter
            </li>
            <li>Lock / Unlock the Issue</li>
            <li>
              Edit the <i>Title</i>, <i>Updated At</i> and <i>Feedback</i>{' '}
              fields
            </li>
            <li>
              Add a custom <i>Observation</i> about the Issue (which will be
              persisted locally and not with the Issue)
            </li>
          </ul>{' '}
        </p>
        <h2> AdapTable Functionality</h2>
        The demo application includes a large number of functionality and
        workflow support provided by AdapTable. This is divided into:
        <ul>
          <li>Adaptable Options - settings to use AdapTable</li>
          <li>
            Predefined Configuration - initial objects saved in Adaptable State
          </li>
        </ul>
        <h3>Predefined Config </h3>
        <p>
          {' '}
          <a
            href="https://docs.adaptabletools.com/guide/reference-config-overview"
            target="_blank"
          >
            Predefined Config
          </a>{' '}
          is used to load an Application with the AdapTable objects it needs for
          first time use.
        </p>
        <p>
          Depending on the{' '}
          <a
            href="https://docs.adaptabletools.com/guide/handbook-permissioning"
            target="_blank"
          >
            Entitlements
          </a>{' '}
          which have been set, run-time users are then able to edit or delete
          these objects, and create their own, and the merged set will be
          automatically stored in{' '}
          <a
            href="https://docs.adaptabletools.com/guide/dev-guide-adaptable-state"
            target="_blank"
          >
            Adaptable State
          </a>
          .
        </p>
        <p>
          The demo application includes a number of Predefined Config objects:
        </p>
        <h4>
          {' '}
          <a
            href="https://docs.adaptabletools.com/guide/ui-dashboard"
            target="_blank"
          >
            Dashboard
          </a>
        </h4>
        <ul>
          <li>
            <i>IsInline</i> is set to true so it shows the Inline view
          </li>
          <li>
            3 Tabs are provided:
            <ol>
              <li>
                <i>Main</i>: Contains Layout, Alert, DataSet, Export and System
                Status Toolbars
              </li>
              <li>
                <i>Edit</i>: Contains Issues Management (a Custom Toolbar),
                DataChangeHistory and BulkUpdate Toolbars
              </li>
              <li>
                <i>Search</i>: Contains Query and Quick Search Toolbars
              </li>
            </ol>
          </li>
          <li>
            2 Module Buttons provided: <i>Settings</i>, <i>Application Info</i>
            (a custom one)
          </li>
        </ul>
        <h4>
          {' '}
          <a
            href="https://docs.adaptabletools.com/guide/ui-tool-panel"
            target="_blank"
          >
            Tool Panel
          </a>
        </h4>
        <ul>
          <li>
            <i>My Issues</i> Custom ToolPanel which is set to be expanded when
            the Application starts
          </li>
        </ul>
        <h4>
          {' '}
          <a
            href="https://docs.adaptabletools.com/guide/handbook-alerting"
            target="_blank"
          >
            Alert
          </a>
        </h4>
        <ul>
          <li>
            One Alert which fires when an Issue is assigned to Current User:
            <ul>
              <li>Uses the Custom Predicate 'my-assignments'</li>
              <li>Scope of 1 column - 'assignee:login'</li>
              <li>Message Type of Info</li>
              <li>
                Contains a Form with 2 buttons:
                <ol>
                  <li>
                    Set In Progress - changes the State of the Issue to 'In
                    Progress'
                  </li>
                  <li>OK - which closes the Alert</li>
                </ol>
              </li>
            </ul>
          </li>
        </ul>
        <h4>
          {' '}
          <a
            href="https://docs.adaptabletools.com/guide/handbook-calculated-column"
            target="_blank"
          >
            Calculated Column
          </a>
        </h4>
        <ul>
          <li>
            Calculated Column called <i>Days Old</i> of type Number
          </li>
          <li>
            Contains the Scalar Expression:{' '}
            <code>DIFF_DAYS(TODAY(), [created_at])</code>
          </li>
        </ul>
        <h4>
          {' '}
          <a
            href="https://docs.adaptabletools.com/guide/handbook-conditional-styling"
            target="_blank"
          >
            Conditional Style
          </a>
        </h4>
        4 Conditional Styles have been provided:
        <ul>
          <li>For State of 'Closed' - colour? row-based</li>
          <li>
            For My Assigned Issues (using Named Query) - colour? row-based
          </li>
          <li>
            For non-closed Issues created in last the day - colour? row-based
          </li>
          <li>For older non-closed issues - colour? row-based</li>
        </ul>
        <h4>
          {' '}
          <a
            href="https://docs.adaptabletools.com/guide/handbook-sorting"
            target="_blank"
          >
            Custom Sort
          </a>
        </h4>
        <ul>
          <li>Custom Sort on 'assignee:login' Column</li>
          <li>
            sorts the column first by Current User and then other values
            alphabetically
          </li>
        </ul>
        <h4>
          {' '}
          <a
            href="https://docs.adaptabletools.com/guide/handbook-data-sets"
            target="_blank"
          >
            Data Set
          </a>
        </h4>
        <ul>
          <li>
            There are 3 Data Sets - each of which loads a different Data Set
            <ul>
              <li>VS Code</li>
              <li>AG Grid</li>
              <li>React (the Default)</li>
            </ul>
          </li>
          <li>
            {' '}
            The <i>alternativeModuleName</i> property in General Options is used
            to rename the Module to 'GitHub Repo Selector'
          </li>
        </ul>
        <h4>
          {' '}
          <a
            href="https://docs.adaptabletools.com/guide/handbook-exporting"
            target="_blank"
          >
            Export
          </a>
        </h4>
        3 User Reports defined (all of which contain custom Column sets):
        <ol>
          <li>
            'My Assigned Issues' - uses this Expression which contains a Named
            Query: <code>QUERY("My Assigned Issues")</code>
          </li>
          <li>
            'Issues Created by Me' - uses this Expression which also contains a
            Named Query: <code>QUERY("Created by me")</code>
          </li>
          <li>
            'My Issues Assigned Today' - uses this Expression which contains 2
            Named Queries:{' '}
            <code>QUERY("Created today") AND QUERY("My Assigned Issues")</code>
          </li>
        </ol>
        <h4>
          {' '}
          <a
            href="https://docs.adaptabletools.com/guide/handbook-column-formatting"
            target="_blank"
          >
            Format Column
          </a>
        </h4>
        <ul>
          <li>
            All Date Columns use a DateFormatter with format: 'dd-MM-yyyy'
          </li>
          <li>The 'Locked' Column displays the CheckBox Style</li>
        </ul>
        <h4>
          {' '}
          <a
            href="https://docs.adaptabletools.com/guide/handbook-freetext-column"
            target="_blank"
          >
            Free Text Column
          </a>
        </h4>
        <ul>
          <li>One Free Text Column called 'Observation' (of type String)</li>
        </ul>
        <h4>
          {' '}
          <a
            href="https://docs.adaptabletools.com/guide/handbook-layouts"
            target="_blank"
          >
            Layouts
          </a>
        </h4>
        <p>
          Layouts manage column sets, i.e. order, visibility, grouping, pinning
          and related elements.
        </p>
        <p> There are 3 Layouts in the Demo Application.</p>
        <ul>
          <li>
            <i>Grid View</i> (the default)
            <ul>
              <li>Shows the key columns in normal table format</li>
              <li>
                <i>Id</i> and <i>Title</i> columns are pinned left and the
                'Action' column is pinned right
              </li>
              <li>
                Sorted by the <i>Author</i> column
              </li>
            </ul>
          </li>
          <li>
            <i>Grouped by User</i>
            <ul>
              <li>
                Has grouping set to the <i>Author</i> Column
              </li>
              <li>Sorts by 'assignee:login' in descending order</li>
            </ul>{' '}
          </li>
          <li>
            <i>Grouped by State</i>
            <ul>
              <li>Grouping set to the 'state' Column</li>
            </ul>{' '}
          </li>
        </ul>
        <h4>
          {' '}
          <a
            href="https://docs.adaptabletools.com/guide/handbook-editing#plus-minus"
            target="_blank"
          >
            Plus / Minus
          </a>
        </h4>
        <ul>
          <li>
            One Plus / Minus Rule (with Nudge Value of 1) on the 'Reactions'
            column
          </li>
        </ul>
        <h4>
          {' '}
          <a
            href="https://docs.adaptabletools.com/guide/handbook-querying"
            target="_blank"
          >
            Query
          </a>
        </h4>
        3 Named Queries are provided:{' '}
        <ul>
          <li>
            <i>My Assigned Issues</i> with Expression:{' '}
            <code>GET_MY_USER_NAME() = [assignee:login]</code>
          </li>
          <li>
            <i>Created By Me</i> with Expression:{' '}
            <code>GET_MY_USER_NAME() = [user:login]</code>
          </li>
          <li>
            <i>Created Today</i> with Expression:{' '}
            <code>DIFF_DAYS(TODAY(), [created_at]) = 0</code>
          </li>
        </ul>
        <h3>Adaptable Options</h3>
        <p>
          When creating an Application using AdapTable there is a wealth of
          configuration options, settings and user-provided functions that can
          be provided, in order to meet any requirement or use case.{' '}
        </p>
        <p>
          These are all contained in{' '}
          <a
            href="https://docs.adaptabletools.com/guide/reference-options-overview"
            target="_blank"
          >
            Adaptable Options
          </a>
          which is configured at design-time and passed into the Adaptable
          constructor.{' '}
        </p>
        <p>
          Adaptable Options is divided up into logical sections each of which
          contains many properties (with default values) and 'function hooks'.
        </p>
        <p>
          The Adaptable Options properties configured for this demo include:
        </p>
        <h4>
          {' '}
          <a
            href="https://docs.adaptabletools.com/guide/reference-options-adaptableql"
            target="_blank"
          >
            AdaptableQL Options
          </a>
        </h4>
        <ul>
          <li>
            Provides a new Scalar Expression Function called 'GET_MY_USER_NAME'
            which returns the Current User's name
          </li>
        </ul>
        <h4>
          {' '}
          <a
            href="https://docs.adaptabletools.com/guide/reference-options-edit"
            target="_blank"
          >
            Edit Options
          </a>
        </h4>
        <ul>
          <li>
            Implements **isCellEditable** function returning true for the
            'assignee:login' column (in all cases) and the editable columns in
            rows where the Issue is assigned to the Current User
          </li>
        </ul>
        <h4>
          {' '}
          <a
            href="https://docs.adaptabletools.com/guide/reference-options-entitlement"
            target="_blank"
          >
            Entitlement Options
          </a>
        </h4>
        <ul>
          <li>
            Theme, CellSummary and Shortcut Modules are set to 'Hidden' (as they
            are not required) - Query Module is set to 'ReadOnly' (so Queries
            can be run but not saved){' '}
          </li>
        </ul>
        <h4>
          {' '}
          <a
            href="https://docs.adaptabletools.com/guide/reference-options-dashboard"
            target="_blank"
          >
            Dashboard
          </a>
        </h4>
        <ul>
          <li>Custom Toolbar called 'Issues Managment'</li>
          <li>
            contains 2 Toolbar Buttons
            <ul>
              <li>Close My Issues</li>
              <li>Get All My Issues</li>
            </ul>{' '}
          </li>
        </ul>
        <h4>
          {' '}
          <a
            href="https://docs.adaptabletools.com/guide/reference-options-filter"
            target="_blank"
          >
            Filter Options
          </a>
        </h4>
        <ul>
          <li>
            Provides implementation for **hideQuickFilterDropdown** so that we
            dont see the Dropdown part in the Quick Filter Bar for Boolean
            columns (as there is nothing much to show and it takes up space) -
          </li>
          <li>
            `quickFilterTrigger` set to *click* (rather than default of
            *mouseenter*)
          </li>
        </ul>
        <h4>
          {' '}
          <a
            href="https://docs.adaptabletools.com/guide/reference-options-custom-predicate-defs"
            target="_blank"
          >
            Custom Predicate Definitions
          </a>
        </h4>
        <ul>
          <li>3 Custom Predicate Definitions have been provided</li>
          <li>
            They can all used in Alerts, Filters and Conditional Styles):
            <ul>
              <li>Live - where _State_ is 'open' or 'in-progress'</li>
              <li>My Issue - where the _user:Login_ is the Current User</li>
              <li>
                My Assignments - where the _assignee:Login_ is the Current User
              </li>
            </ul>
          </li>
        </ul>
        <h4>
          {' '}
          <a
            href="https://docs.adaptabletools.com/guide/reference-options-general"
            target="_blank"
          >
            General Options
          </a>
        </h4>
        <ul>
          <li>
            2 AlternativeModuleNames:
            <ol>
              <li>
                'GitHub Repo Selector' (previously <i>DataSet</i> Module)
              </li>
              <li>
                'Overview' (previously <i>System Status</i> Module)
              </li>
            </ol>
          </li>
        </ul>{' '}
        <h4>
          {' '}
          <a
            href="https://docs.adaptabletools.com/guide/reference-options-menu"
            target="_blank"
          >
            Menu Options
          </a>
        </h4>
        <ul>
          <li>
            Provides implementation for <i>showAdaptableColumnMenu</i> so that
            we dont see any Adaptable menu items in Column Menu in the Action
            Column
          </li>
          <li>
            Adds 'Show Issues' Column Menu Item:
            <ul>
              <li>Only appears in the 'Assigned To' Column</li>
              <li>
                Text is "Show All Issues" / "Show My Issues" (depending on
                current filter)
              </li>
              <li>
                When clicked turns on / off the 'My Assigned Issues' Custom
                Predicate Filter
              </li>
            </ul>
          </li>
          <li>
            Adds 'Assign To Me' Context Menu Item:
            <ul>
              <li>Hidden if Issue is already assigned to Current User</li>
              <li>Assigns the Issue to Current User when clicked</li>
            </ul>
          </li>
          <li>
            Adds 'Open / Close Issue' Context Menu Item:
            <ul>
              <li>Label changes based on whether Issue State is 'closed'</li>
              <li>Hidden if Issue is not currently assigned to Current User</li>
              <li>
                Sets the state of the Issue to 'Open' or 'Closed' (depending on
                current state) when clicked
              </li>
            </ul>
          </li>
        </ul>
        <h4>
          {' '}
          <a
            href="https://docs.adaptabletools.com/guide/reference-options-notification"
            target="_blank"
          >
            Notification Options
          </a>
        </h4>
        <ul>
          <li>
            Provides an Action Handler called 'set-in-progress' (used in the
            Alert)
          </li>
          <li>
            Sets some notification properties (overriding defaults):
            <ul>
              <li>Duration of 1 second</li>
              <li>Progress Bar is visible</li>
              <li>Closes when clicked</li>
              <li>Pauses when hovering</li>
            </ul>
          </li>
        </ul>
        <h4>
          {' '}
          <a
            href="https://docs.adaptabletools.com/guide/reference-options-tool-panel"
            target="_blank"
          >
            Tool Panel Options
          </a>
        </h4>
        <ul>
          <li>
            Custom ToolPanel called 'My Issues' which contains 2 ToolPanel
            Buttons:
            <ul>
              <li>Close My Issues</li>
              <li>Get All My Issues</li>
            </ul>
          </li>
        </ul>
        <h4>
          {' '}
          <a
            href="https://docs.adaptabletools.com/guide/reference-options-user-interface"
            target="_blank"
          >
            User Interface Options
          </a>
        </h4>
        <ul>
          <li>
            Sets the Cell Style for editable cells (has a light green border)
          </li>
          <li>
            Adds an Edit LookUp Item for the <i>State</i> Column with values to
            show in dropdown when editing
          </li>
          <li>
            Provides an Action Column called <i>actions</i> with these features:
            <ul>
              <li>
                Label is 'Assign Me' when not my Issue; otherwise 'close' or
                'open' depending on the state of the Issue
              </li>
              <li>
                When clicked it Assigns the Issue to Current User (if not
                already his); otherwise it closes or opens the Issue depending
                on its current state
              </li>
              <li>
                The Button's Style changes based on whether its Current User's
                Issue, and the State of the Issue
              </li>
              <li></li>
            </ul>
          </li>
          <li>
            An <i>applicationIcon</i> is provided (taken from Github)
          </li>
        </ul>
      </div>
    </div>
  );
};
